import { defer } from "react-router-dom";
import { resolveLoaderResult } from "@/routes/loaderResult";
import { getGuidePage } from "../common/service";

export function limitGuideLoader() {
  return defer({
    coreData: resolveLoaderResult(getGuidePage()),
  });
}
